import React, { useEffect, useState } from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';

import './style.scss';

const SearchHeader = ({ data }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    if (!data || typeof data.results === 'undefined') return;

    const currentPageNumber = data.results.hits.page.pageNumber;
    const dataChanged = JSON.stringify(currentData) !== JSON.stringify(data);

    if (dataChanged) {
      if (items.length === 0 || currentPageNumber === 0) {
        setItems([...data.results.hits.items]);
      } else {
        setItems([...items, ...data.results.hits.items]);
      }

      setCurrentData(data);
    }
  }, [data, currentData]);

  const itemsFound = items.reduce((value, item) => {
    if (item.inside_area === 0) {
      return value;
    }
    return value + 1;
  }, 0);

  if (itemsFound === 0) {
    return (
      <div className="SearchHeader--no-results">
        <h5>{t('nldoet.search_header.no_results_title')}</h5>
        <CoreLink href="https://formulieren.oranjefonds.nl/updates_nldoet_vrijwilligers_gezocht_in_mijn_gemeente" rel="noreferrer" target="_blank">{t('nldoet.search_header.no_results_link')}</CoreLink>
      </div>
    );
  }

  return (
    <h4 className="SearchHeader">{t('nldoet.search_header.activities_found', { count: itemsFound })}</h4>
  );
};

export default SearchHeader;
